import React, { useState } from 'react';
import UserViewComponent from './UserManagmentView';
import HealthFacilityView from './HealthFacilityView';
import './AppWrapperViewComponent.css';
import ZoneManagementView from './ZoneManagementView';
import HealthBlockManagementView from '../GeoNonGeo/NonGeo/healthBlockManagement';
import CreateNewFacility from '@pages/FacilityManagement/CreateNewFacility';
import CreateNewUser from '@pages/UserManagement/CreateNewUser';
import CreateNewGeo from '@pages/GeoNonGeo/Geo/create';
import CreateNewNonGeo from '@pages/GeoNonGeo/NonGeo/create';
import CreateBeneficiary from '@pages/Beneficiary-block/CreateBeneficiary';
import CreateNewRole from '@pages/UserManagement/CreateNewRole';
import RoleManagementView from '@pages/UserManagement/RoleManagementView';
import RoleManagementUpdate from '@pages/UserManagement/RoleManagementUpdate';
import WomenComponent from '@pages/Beneficiary-block/WomenComponent';
import CreateNewChild from '@pages/Beneficiary-block/WomenComponent/CreateNewChild';
import TemporaryBenificiary from '@pages/Beneficiary-block/CreateBeneficiary/TemporaryBenificiary';
import FacilityDetails from '@pages/Beneficiary-block/WomenComponent/ANC/FacilityDetails';
import PNCFacilityDetails from '@pages/Beneficiary-block/WomenComponent/PNC/PNCFacilityDetails';
import CreateVhndUhnd from '@pages/GeoNonGeo/vhnduhnd/createVhndUhnd';
import VhndUhndView from '@pages/GeoNonGeo/vhnduhnd/viewVhndUhnd';
import ChildHbyc from '@pages/Beneficiary-block/WomenComponent/Child/form/ChildHbyc';
import MigratedTemporaryBenificiary from '@pages/Beneficiary-block/WomenComponent/edit/MigratedBenfTemp';
import MigratedBenificiaryView from '@pages/Beneficiary-block/WomenComponent/view/MigratedBeneficiaryView';
import ApprovalHealthFacilityView from '@pages/Approval/OverViewLayout';
import SickChildCare from '@pages/Beneficiary-block/WomenComponent/Child/ChildServices/SickChildCare';

const AppWrapperViewComponent = (props: any) => {
  return (
    <>
      {(props.page === 'user' && props.flow === 'create') ? (
        <CreateNewUser page={props.page} flow={props.flow} />
      )
      : (props.page === 'user_role' && props.flow === 'createNewRole') ? (
       <CreateNewRole page={props.page} flow={props.flow} />)
      : (props.page === 'user_role' && props.flow === 'viewRole') ? (
        <RoleManagementView page={props.page} flow={props.flow} />)
      : (props.page === 'user_role' && props.flow === 'editRole') ? (
        <RoleManagementUpdate page={props.page} flow={props.flow} />)
      : (props.page === 'user') ? (
        <UserViewComponent page={props.page} flow={props.flow} />
      ) : (props.page === 'health_facility' && props.flow === 'create') ? (
        <CreateNewFacility page={props.page} flow={props.flow} />
      ) : props.page === 'health_facility' ? (
        <HealthFacilityView page={props.page} flow={props.flow} />
      ) : (props.page === 'zone_details' && props.flow === 'create') ? (
        <CreateNewGeo page={props.page} flow={props.flow} />
      ) : (props.page === 'zone_details') ? (
        <ZoneManagementView page={props.page} flow={props.flow} />
        
       ) : (props.page === 'health_block' && props.flow === 'create') ? (
        <CreateNewNonGeo page={props.page} flow={props.flow} />
      ) : (props.page === 'temporaryRegistration' && props.flow ==='temp') ? (
        <TemporaryBenificiary page={props.page} flow={props.flow} />
       ) : (props.page === 'health_block') ?
        <HealthBlockManagementView page={props.page} flow={props.flow} />
        : (props.page==='beneficiary' && props.flow === 'create')?
        <CreateBeneficiary page={props.page} flow={props.flow} /> :
        (props.page === 'beneficiary' && props.flow === 'createNewChild') ?
        <CreateNewChild flow={props.flow} page={props}/>:
        (props.page==='beneficiary' && props.flow === 'ancService')?
        <FacilityDetails /> :
        (props.page==='beneficiary' && props.flow === 'pncService')?
        <PNCFacilityDetails childService={false} /> :
        (props.page==='beneficiary' && props.flow === 'childService')?
        <PNCFacilityDetails childService={true} /> :
        (props.page==='beneficiary' && props.flow === 'createHbyc')? 
        <ChildHbyc /> : 
        (props.page==='beneficiary' && props.flow==='createSickChildCare')?
        <SickChildCare /> :
        (props.page==='beneficiary' && props.flow === 'abortion')? 
        <PNCFacilityDetails childService={false} /> :   
        (props.page==='beneficiary' && props.flow === 'edit-temp')?
        <MigratedTemporaryBenificiary page={props.page} flow={props.flow} /> :
        (props.page==='beneficiary' && props.flow === 'view-temp')?
        <MigratedBenificiaryView page={props.page} flow={props.flow} /> :
        (props.page==='beneficiary')?
        <WomenComponent page={props.page} flow={props.flow} /> : 
        (props.page === 'vhnd_uhnd_block' && props.flow === 'create') ? (
          <CreateVhndUhnd page={props.page} flow={props.flow} />
        ) : props.page === 'vhnd_uhnd_block' ? (
          <VhndUhndView page={props.page} flow={props.flow} />
        ) : props.page === 'approval_overView' ? (
          <ApprovalHealthFacilityView page={props.page} flow={props.flow} />
        ) :('')
        }  
    </>
  );
};

export default AppWrapperViewComponent;